import React, { useEffect, useState, useCallback, useRef } from "react";
import { InputGroup, FloatingLabel, Badge, FormControl, Table, Checkbox, Container, Button, Dropdown, DropdownButton, Form, Col, Row, Popover, OverlayTrigger, Tooltip, ListGroup } from 'react-bootstrap';
import { useOuterClick, currencyFormat, deepFind } from '../../../helper/Helper'
import ErrorManager from "../../../components/error-manager/ErrorManager";
import TagInput from "./filter-inputs/TagInput";
import TypeRender from './type-render/TypeRender';
import './DynamicTable.scss';

const DynamicTable = (props) => {

    const [activeRowId, setActiveRowId] = useState(null)
    const [selectedRowId, setSelectedRowId] = useState(null)
    const [filters, setFilters] = useState(null)
    const [sort, setSort] = useState()
    const [order, setOrder] = useState()
    const [colSizeRatio, setColSizeRatio] = useState()
    const [globalError, setGlobalError] = useState()
    const [contextMenu, setContextMenu] = useState({ xPos: null, yPos: null, showMenu: false, tableBodyElement: null })

    let tableNavigation = useRef(false)
    const changeRowTimerRef = useRef(null)

    const outerClickTable = useOuterClick(ev => {
        tableNavigation.current = false
        //setSelectedRowId()
    })
    const outerClickContextMenu = useOuterClick(ev => {
        setContextMenu({ xPos: null, yPos: null, showMenu: false, tableBodyElement: null })
    })


    /* Applique un indicateur visuel si un scroll horizontal existe */

    let dynamicTableRef = useRef()

    const useIsOverflow = (ref, callback) => {
        const [isOverflow, setIsOverflow] = React.useState(undefined);
        React.useLayoutEffect(() => {
            const { current } = ref
            const trigger = () => {
                const hasOverflow = current.scrollWidth > current.clientWidth
                setIsOverflow(hasOverflow)
                if (callback) callback(hasOverflow)
            }
            if (current) {
                if ('ResizeObserver' in window) {
                    new ResizeObserver(trigger).observe(current);
                }
                trigger();
            }
        }, [callback, ref]);
        return isOverflow;
    };

    useEffect(() => {
        const ref = dynamicTableRef.current;
        const handleScroll = () => {
            const endScroll = ref.scrollWidth - ref.scrollLeft === ref.clientWidth
            if (endScroll) {
                ref.className = ""
            } else {
                ref.className = "horizontal-scroll-info"
            }
        }
        if (ref) {
            ref.addEventListener('scroll', handleScroll);
            return () => ref.removeEventListener('scroll', handleScroll);
        }
    }, []);

    useIsOverflow(dynamicTableRef, (overflow) => {
        const ref = dynamicTableRef.current
        if (ref) {
            if (ref.scrollWidth - ref.scrollLeft === ref.clientWidth) {
                ref.className = ""
            } else {
                ref.className = "horizontal-scroll-info"
            }
        }
    })

    /* FIN : Applique un indicateur visuel si un scroll horizontal existe */


    useEffect(() => {
        setSort(props.params.sort)
    }, [props.params.sort]);

    useEffect(() => {
        if (props.currentElement) {
            selectRow(props.currentElement)
        }
    }, [props.currentElement]);

    useEffect(() => {
        setOrder(props.params.order)
    }, [props.params.order]);

    useEffect(() => {
        setFilters(props.params.filters)
    }, [props.params.filters]);

    useEffect(() => {
        if (props.tableHeaders) {
            let totalSizeValue = 0
            props.tableHeaders.filter(h => h.hidden != true).map(h => { totalSizeValue = totalSizeValue + h.colSize })
            setColSizeRatio(100 / totalSizeValue)
        }
    }, [props.tableHeaders]);

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);


    function handleKeyDown(e) {
        if (activeRowId && tableNavigation.current) {
            const { code } = e;
            switch (code) {
                case "ArrowUp":
                    e.preventDefault()
                    prevRow()
                    break;
                case "ArrowDown":
                    e.preventDefault()
                    nextRow()
                    break;
                case "ArrowRight":
                    break;
                case "ArrowLeft":
                    break;
                case "Space":
                    e.preventDefault()
                    handleCheckboxChange(selectedRowId)
                    break;
                case "Escape":
                    //props.changeCurrentElement();
                    break;
                default:
                    break;
            }
        }
    }

    function changeFilters(f) {
        setFilters(f)
        props.changeFilters(f)
    }

    function setError(error) {
        setGlobalError(error)
    }

    function selectRow(tableBodyElement) {
        setSelectedRowId(tableBodyElement._id)
        setActiveRowId(tableBodyElement._id)
        tableNavigation.current = true
        props.changeCurrentElement(tableBodyElement);
    }

    function onContextMenu(e, tableBodyElement) {
        if (e.type === 'contextmenu') {
            //selectRow(tableBodyElement)
            setContextMenu({
                xPos: `${e.pageX}px`,
                yPos: `${e.pageY}px`,
                showMenu: true,
                tableBodyElement: tableBodyElement
            })
            e.preventDefault()
        }
    }

    const ContextMenu = () => {

        function onClickAction(e, element, tableBodyElement) {
            props.setElementAction(element.action, tableBodyElement)
            setContextMenu({ xPos: null, yPos: null, showMenu: false, tableBodyElement: null })
        }

        if (contextMenu.showMenu && (props.elementActions.length > 0)) {
            return (
                <ListGroup
                    ref={outerClickContextMenu}
                    className="position-fixed zindex-3000 shadow"
                    style={{
                        top: contextMenu.yPos,
                        left: contextMenu.xPos,
                    }}
                >
                    {props.elementActions.map((element, i) => {
                        // Cache le bouton d'action si une condition est présente dans "disableKeyValues" 
                        let visible = true
                        element?.disableKeyValues && Object.keys(element.disableKeyValues)?.map((key, index) => {
                            element.disableKeyValues[key].indexOf(deepFind(contextMenu.tableBodyElement, key)) > -1 && (
                                visible = false
                            )
                        })
                        if (visible) {
                            return (
                                <ListGroup.Item className="d-flex align-items-center" key={element.title} action onClick={(e) => onClickAction(e, element, contextMenu.tableBodyElement)}>
                                    <i className="material-icons me-2" style={{ fontSize: '16px' }}>{element.icon}</i>
                                    {element.title}
                                </ListGroup.Item>
                            )
                        }
                    })}
                </ListGroup>
            )
        }

    }

    function prevRow() {
        let index = selectedRowId ? props.tableDataList.findIndex(e => e._id === selectedRowId) : props.tableDataList.findIndex(e => e._id === activeRowId);
        if (index != 0) {
            // setActiveRowId(tableBody[index -1]._id)
            setSelectedRowId(props.tableDataList[index - 1]._id)
            changeCurrentElement(props.tableDataList[index - 1])
        }
    }

    function nextRow() {
        let index = selectedRowId ? props.tableDataList.findIndex(e => e._id === selectedRowId) : props.tableDataList.findIndex(e => e._id === activeRowId);
        if (index + 1 < props.tableDataList.length) {
            setSelectedRowId(props.tableDataList[index + 1]._id)
            changeCurrentElement(props.tableDataList[index + 1])
        }
    }

    let changeCurrentElement = (element) => {
        if (changeRowTimerRef.current) {
            clearTimeout(changeRowTimerRef.current);
        }
        changeRowTimerRef.current = setTimeout(() => {
            props.changeCurrentElement(element)
            setActiveRowId(element._id)
        }, 500);
    }

    const handleCheckboxChange = (value) => {
        let checkedElementIdList = [...props.checkedElementIdList];
        let index = checkedElementIdList.indexOf(value)
        if (index >= 0) {
            checkedElementIdList = checkedElementIdList.filter(id => id !== value)
        } else {
            checkedElementIdList.push(value)
        }
        props.setCheckedElementIdList(checkedElementIdList)
    }

    const handleHeaderCheckboxChange = (event) => {
        // si aucun élément n'est coché, ça coche tout, sinon, ça décoche tout
        let checkedElementIdListCopy = [...props.checkedElementIdList];
        const filteredTableBody = props.tableDataList.filter(i => props.checkedElementIdList.includes(i._id))
        if (!filteredTableBody.length) {
            props.tableDataList.map(e => checkedElementIdListCopy.push(e._id))
        } else {
            props.tableDataList.map(e => {
                let index = checkedElementIdListCopy.indexOf(e._id)
                if (index >= 0) {
                    checkedElementIdListCopy.splice(index, 1)
                }
            })
        }
        props.setCheckedElementIdList(checkedElementIdListCopy)
    }

    function setHeaderCheckbox(input) {

        const filteredTableBody = props.tableDataList.filter(i => props.checkedElementIdList?.includes(i._id))

        input.checked = false;
        input.indeterminate = false;

        if (filteredTableBody.length == props.tableDataList.length) {
            input.checked = true;
        } else if (filteredTableBody.length > 0) {
            input.indeterminate = true;
        }

    }

    function setItemFilter(operation, dataTarget, value) {

        let filtersCopy = { ...filters }

        //si le filtre n'existe pas, on le crée :
        if (!filtersCopy[`filter[${dataTarget}]`]) {
            filtersCopy[`filter[${dataTarget}]`] = []
        }

        // index de l'opérateur concerné
        let index = filtersCopy[`filter[${dataTarget}]`].findIndex(object => {
            return object.operation == operation;
        });

        // on supprime l'opérateur
        if (index > -1) {
            filtersCopy[`filter[${dataTarget}]`].splice(index, 1)
        }

        let obj

        switch (operation) {
            case 'contain_str':
                obj = (value ? { operation: operation, operator: "", value: `${value}` } : null)
                break;
            case 'no_contain_str':
                obj = (value ? { operation: operation, operator: "!", value: `${value}` } : null)
                break;
            case 'start_by_str':
                obj = (value ? { operation: operation, operator: "^", value: `${value}` } : null)
                break;
            case 'equal_to':
                obj = (value ? { operation: operation, operator: "=", value: `${value}` } : null)
                break;
            case 'different_to':
                obj = (value ? { operation: operation, operator: "!=", value: `${value}` } : null)
                break;
            case 'greater_than':
                obj = (value ? { operation: operation, operator: ">", value: `${value}` } : null)
                break;
            case 'lower_than':
                obj = (value ? { operation: operation, operator: "<", value: `${value}` } : null)
                break;
            case 'lower_or_equal_than':
                obj = (value ? { operation: operation, operator: "<=", value: `${value}` } : null)
                break;

            default:
                break;
        }

        // ajouter l'objet
        obj && filtersCopy[`filter[${dataTarget}]`]?.push(obj)

        // supprimer le filtre si vide
        if (filtersCopy[`filter[${dataTarget}]`].length == 0) {
            delete filtersCopy[`filter[${dataTarget}]`]
        }

        return Object.keys(filtersCopy).length === 0 ? null : filtersCopy

    }

    function getInputValue(operation, header) {
        let element = filters && filters[`filter[${header.dataTarget}]`]?.filter(f => f.operation == operation)
        return (element && element[0]?.value) ? element[0]?.value : ''
    }

    function displayType(header, typeList) {
        return typeList.indexOf(header.type) > -1 ? true : false
    }

    function changeSortOrder(header) {
        let o = order == 'asc' ? 'desc' : 'asc'
        let sortPath = header.dbField ? header.dbField : header.dataTarget
        if (sortPath != sort) {
            o = 'asc'
        }
        props.changeSortOrder(sortPath, o)
    }

    return (

        <div id="DynamicTable" ref={dynamicTableRef}>

            <ErrorManager error={globalError} fixed="true" />

            <ContextMenu />

            {props.tableHeaders &&
                <Table ref={outerClickTable} hover className="position-relative">

                    <thead className="">
                        <tr>
                            <th className="w-checkbox pe-4 align-top">
                                {props.tableDataList &&

                                    <input
                                        type="checkbox"
                                        ref={input => {
                                            if (input) {
                                                setHeaderCheckbox(input)
                                            }
                                        }}

                                        className="form-check-input mt-1"
                                        onChange={handleHeaderCheckboxChange} />
                                }
                            </th>
                            {props.tableHeaders.map((header, i) => {
                                return header.hidden ? null :
                                    <th key={header.dataTarget} style={{ width: colSizeRatio * header.colSize + '%' }} className="align-top">

                                        {header.sortable &&
                                            <span className={"text-uppercase text-gray-600 small mt-1 cursor-pointer d-flex align-items-top " + (header.align == 'right' ? 'justify-content-end ' : '')} onClick={() => changeSortOrder(header)}>
                                                <div className="d-flex flex-column">
                                                    {header.label}
                                                    {(header.dbField && (header.dataTarget == sort || header.dbField == sort)) &&
                                                        <span className="small">Trié sur : "{header.dbField}"</span>
                                                    }
                                                </div>
                                                {(order == "desc" && (header.dataTarget == sort || header.dbField == sort)) &&
                                                    <i className="material-icons ms-2" >north</i>
                                                }
                                                {(order == "asc" && (header.dataTarget == sort || header.dbField == sort)) &&
                                                    <i className="material-icons ms-2" >south</i>
                                                }
                                            </span>
                                        }
                                        {!header.sortable &&
                                            <span className="text-uppercase text-gray-600 small mt-1 d-flex align-items-top">
                                                <div className="d-flex flex-column">
                                                    {header.label}
                                                </div>
                                            </span>
                                        }

                                        {props?.isTableFilterVisible &&

                                            // Filtres de recherche
                                            <>
                                                {!header.filters ?
                                                    <Form.Control
                                                        size="sm"
                                                        type="text"
                                                        disabled
                                                        placeholder='Indisponible'
                                                    />
                                                    :
                                                    <InputGroup size="sm" className="no-btn-caret">

                                                        {/* <Form.Control
                                                            value={getInputValue('contain_str', header)}
                                                            onChange={e => changeFilters(setItemFilter('contain_str', header, e.target.value))}
                                                            size="sm"
                                                            type="search"
                                                            placeholder='TAGS'
                                                        /> */}

                                                        {(
                                                            displayType(header, ['tags'])
                                                        ) &&
                                                            <Form.Control
                                                                value=""
                                                                readOnly
                                                                className="bg-white text-gray-600"
                                                                size="sm"
                                                                type="text"
                                                                placeholder='Fitrer par tags'
                                                            />
                                                        }
                                                        {(
                                                            displayType(header, ['string']) ||
                                                            displayType(header, ['markdown']) ||
                                                            displayType(header, ['genericList']) ||
                                                            displayType(header, ['codesbarres'])
                                                        ) &&
                                                            <Form.Control
                                                                value={getInputValue('contain_str', header)}
                                                                onChange={e => changeFilters(setItemFilter('contain_str', header.dataTarget, e.target.value))}
                                                                size="sm"
                                                                type="search"
                                                                placeholder='Contient'
                                                            />
                                                        }
                                                        {(
                                                            displayType(header, ['boolean']) ||
                                                            displayType(header, ['booleanTrueOnly']) ||
                                                            displayType(header, ['booleanFalseOnly']) ||
                                                            displayType(header, ['bloquer'])
                                                        ) &&
                                                            <Form.Control
                                                                value="Filtrer Oui / Non"
                                                                readOnly
                                                                className="bg-white text-gray-600"
                                                                size="sm"
                                                                type="text"
                                                                placeholder='Filtrer'
                                                            />
                                                        }
                                                        {(
                                                            displayType(header, ['date']) ||
                                                            displayType(header, ['dateList'])
                                                        ) &&
                                                            <Form.Control
                                                                value={getInputValue('equal_to', header)}
                                                                onChange={e => changeFilters(setItemFilter('equal_to', header.dataTarget, e.target.value))}
                                                                size="sm"
                                                                type="date"
                                                                placeholder='Égal à'
                                                            />
                                                        }
                                                        {(
                                                            displayType(header, ['number']) ||
                                                            displayType(header, ['percentage']) ||
                                                            displayType(header, ['currency']) ||
                                                            displayType(header, ['currencyHighlightNegative'])
                                                        ) &&
                                                            <Form.Control
                                                                value={getInputValue('equal_to', header)}
                                                                onChange={e => changeFilters(setItemFilter('equal_to', header.dataTarget, e.target.value))}
                                                                size="sm"
                                                                type="number"
                                                                placeholder='Égal à'
                                                            />
                                                        }

                                                        <DropdownButton
                                                            variant={filters && filters[`filter[${header.dataTarget}]`] ? 'warning' : 'secondary'}
                                                            title={<i className="material-icons">filter_alt</i>}
                                                            align="end"
                                                        >
                                                            <span className="px-3 py-2 d-block table-header-dropdown">
                                                                {(
                                                                    displayType(header, ['boolean']) ||
                                                                    displayType(header, ['booleanTrueOnly']) ||
                                                                    displayType(header, ['booleanFalseOnly']) ||
                                                                    displayType(header, ['bloquer'])
                                                                ) &&
                                                                    <>
                                                                        <Form.Group controlId="">
                                                                            <Form.Check
                                                                                inline
                                                                                id={"boolean-1" + header.dataTarget}
                                                                                type="radio"
                                                                                onChange={e => changeFilters(setItemFilter('equal_to', header.dataTarget, 'true'))}
                                                                                label="Oui"
                                                                                name={`${header.dataTarget}-1`}
                                                                                checked={((filters && filters[`filter[${header.dataTarget}]`]) && (filters[`filter[${header.dataTarget}]`]['0'].value == 'true')) ? true : false}
                                                                            />
                                                                        </Form.Group>
                                                                        <Form.Group controlId="">
                                                                            <Form.Check
                                                                                inline
                                                                                id={"boolean-2" + header.dataTarget}
                                                                                type="radio"
                                                                                onChange={e => changeFilters(setItemFilter('equal_to', header.dataTarget, 'false'))}
                                                                                label="Non"
                                                                                name={`${header.dataTarget}-1`}
                                                                                checked={((filters && filters[`filter[${header.dataTarget}]`]) && (filters[`filter[${header.dataTarget}]`]['0'].value == 'false')) ? true : false}
                                                                            />
                                                                        </Form.Group>
                                                                        <Button variant="link" className="p-0" onClick={e => changeFilters(setItemFilter('equal_to', header.dataTarget, null))}>Effacer</Button>
                                                                    </>
                                                                }
                                                                {(
                                                                    displayType(header, ['string']) ||
                                                                    displayType(header, ['codesbarres']) ||
                                                                    displayType(header, ['genericList'])
                                                                ) &&
                                                                    <Form.Group controlId="">
                                                                        <Form.Label className="m-0 small">Égal à</Form.Label>
                                                                        <Form.Control value={getInputValue('equal_to', header)} onChange={e => changeFilters(setItemFilter('equal_to', header.dataTarget, e.target.value))} size="sm" type="search" />
                                                                    </Form.Group>
                                                                }
                                                                {(
                                                                    displayType(header, ['number']) ||
                                                                    displayType(header, ['percentage']) ||
                                                                    displayType(header, ['currency']) ||
                                                                    displayType(header, ['currencyHighlightNegative'])
                                                                ) &&
                                                                    <Form.Group controlId="">
                                                                        <Form.Label className="m-0 small">Différent de</Form.Label>
                                                                        <Form.Control value={getInputValue('different_to', header)} onChange={e => changeFilters(setItemFilter('different_to', header.dataTarget, e.target.value))} size="sm" type="number" />
                                                                    </Form.Group>
                                                                }
                                                                {(
                                                                    displayType(header, ['string']) ||
                                                                    displayType(header, ['markdown']) ||
                                                                    displayType(header, ['codesbarres']) ||
                                                                    displayType(header, ['genericList'])
                                                                ) &&
                                                                    <Form.Group controlId="">
                                                                        <Form.Label className="m-0 small">Ne contient pas</Form.Label>
                                                                        <Form.Control value={getInputValue('no_contain_str', header)} onChange={e => changeFilters(setItemFilter('no_contain_str', header.dataTarget, e.target.value))} size="sm" type="search" />
                                                                    </Form.Group>
                                                                }
                                                                {(
                                                                    displayType(header, ['string']) ||
                                                                    displayType(header, ['markdown']) ||
                                                                    displayType(header, ['codesbarres']) ||
                                                                    displayType(header, ['genericList'])
                                                                ) &&
                                                                    <Form.Group controlId="">
                                                                        <Form.Label className="m-0 small">Commence par</Form.Label>
                                                                        <Form.Control value={getInputValue('start_by_str', header)} onChange={e => changeFilters(setItemFilter('start_by_str', header.dataTarget, e.target.value))} size="sm" type="search" />
                                                                    </Form.Group>
                                                                }
                                                                {(
                                                                    displayType(header, ['number']) ||
                                                                    displayType(header, ['percentage']) ||
                                                                    displayType(header, ['currency']) ||
                                                                    displayType(header, ['currencyHighlightNegative'])
                                                                ) &&
                                                                    <Form.Group controlId="">
                                                                        <Form.Label className="m-0 small">Plus grand que</Form.Label>
                                                                        <Form.Control value={getInputValue('greater_than', header)} onChange={e => changeFilters(setItemFilter('greater_than', header.dataTarget, e.target.value))} size="sm" type="number" />
                                                                    </Form.Group>
                                                                }
                                                                {(
                                                                    displayType(header, ['number']) ||
                                                                    displayType(header, ['percentage']) ||
                                                                    displayType(header, ['currency']) ||
                                                                    displayType(header, ['currencyHighlightNegative'])
                                                                ) &&
                                                                    <Form.Group controlId="">
                                                                        <Form.Label className="m-0 small">Plus petit que</Form.Label>
                                                                        <Form.Control value={getInputValue('lower_than', header)} onChange={e => changeFilters(setItemFilter('lower_than', header.dataTarget, e.target.value))} size="sm" type="number" />
                                                                    </Form.Group>
                                                                }
                                                                {(
                                                                    displayType(header, ['date']) ||
                                                                    displayType(header, ['dateList'])
                                                                ) &&
                                                                    <Form.Group controlId="">
                                                                        <Form.Label className="m-0 small">Date de début</Form.Label>
                                                                        <Form.Control value={getInputValue('greater_than', header)} onChange={e => changeFilters(setItemFilter('greater_than', header.dataTarget, e.target.value))} size="sm" type="date" />
                                                                    </Form.Group>
                                                                }
                                                                {(
                                                                    displayType(header, ['date']) ||
                                                                    displayType(header, ['dateList'])
                                                                ) &&
                                                                    <Form.Group controlId="">
                                                                        <Form.Label className="m-0 small">Date de fin</Form.Label>
                                                                        <Form.Control value={getInputValue('lower_or_equal_than', header)} onChange={e => changeFilters(setItemFilter('lower_or_equal_than', header.dataTarget, e.target.value))} size="sm" type="date" />
                                                                    </Form.Group>
                                                                }
                                                                {/* {(
                                                                    displayType(header, ['tags'])
                                                                ) &&
                                                                    <TagInput filters={filters} dataTarget={`${header.dataTarget}`} onChange={f => changeFilters(setItemFilter('equal_to', f.dataTarget, f.value))} />
                                                                } */}

                                                            </span>

                                                        </DropdownButton>
                                                    </InputGroup>
                                                }
                                            </>

                                        }

                                    </th>

                            })}
                        </tr>
                    </thead>

                    {(props.tableDataList && !props.isDataLoading) &&
                        <tbody>
                            {props.tableDataList.map((tableBodyElement, i) => (
                                <tr key={i} className={"cursor-pointer position-relative align-middle " + ((contextMenu?.tableBodyElement?._id == tableBodyElement._id) ? "table-active " : "") + (tableBodyElement._id == activeRowId ? 'table-active zindex-30 ' : '') + (tableBodyElement._id == selectedRowId ? ' border-primary-100 selected zindex-1' : '')}>

                                    <td className="w-checkbox pe-2">
                                        <input type="checkbox" checked={props.checkedElementIdList?.includes(tableBodyElement._id)} value={tableBodyElement._id} className="form-check-input" onChange={e => handleCheckboxChange(e.target.value)} />
                                    </td>

                                    {props.tableHeaders.map((header, j) => {
                                        if (!header.hidden) {
                                            return <td className={header.align == 'right' ? 'text-end ' : ''} key={j} onClick={() => selectRow(tableBodyElement)} onContextMenu={e => onContextMenu(e, tableBodyElement)}>
                                                {deepFind(tableBodyElement, header.dataTarget) &&
                                                    <TypeRender header={header} tableBodyElement={tableBodyElement} setError={error => setError(error)} />
                                                }
                                            </td>
                                        }
                                    })}

                                    {props.elementActions.length > 0 &&
                                        <td style={{ right: (props.sideWidth && props.sideWidth != 0 ? props.sideWidth + 12 : 0), transition: 'right .4s' }} className={"actions p-0 zindex-20 " + ((props.sideWidth == 0 || !props.sideWidth) ? "" : "actions-alignment")}>
                                            <span>
                                                {props.elementActions.map((element, i) => {

                                                    // Cache le bouton d'action si une condition est présente dans "disableKeyValues"
                                                    let visible = true
                                                    element?.disableKeyValues && Object.keys(element.disableKeyValues)?.map((key, index) => {
                                                        element.disableKeyValues[key].indexOf(deepFind(tableBodyElement, key)) > -1 && (
                                                            visible = false
                                                        )
                                                    })

                                                    if (visible) {
                                                        return (
                                                            <OverlayTrigger
                                                                key={element.title}
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip>
                                                                        {element.title}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <i onClick={() => props.setElementAction(element.action, tableBodyElement)} className="material-icons bg-white hover-bg-gray-200 rounded text-dark">{element.icon}</i>
                                                            </OverlayTrigger>
                                                        )
                                                    }
                                                })}
                                            </span>
                                        </td>
                                    }

                                </tr>

                            ))}

                        </tbody>
                    }
                </Table>
            }

            {props.isDataLoading &&
                <div className="p-3">
                    <span className="hloader"></span>
                </div>
            }

            {(!props.tableDataList && !props.isDataLoading) &&
                <em className="d-block not-found p-3">- Aucun élément trouvé -</em>
            }
        </div>
    );
}

export default DynamicTable;